import React from 'react';
import { Layout } from 'fronton-react';
import {
  HeaderSection,
  OtherSection,
  RootLayout,
} from 'common/components';
import { useIsInViewport, useScrollToElement } from 'common/hooks';
import { ConsultationSection } from 'remotes/consultation-section';
import { PromoBlock } from 'remotes/promo-block';
import { SpecialOffer } from 'remotes/special-offer';
import {
  INTERIOR_DOORS_HEADER_CDN_PATH,
  INTERIOR_DOORS_ELEMENT_BLOCK,
  INTERIOR_DOORS_PATH,
  INTERIOR_DOORS_OLD_LANDING_NAME,
} from './interior-doors-constants';
import {
  InteriorDoorsModernMaterials,
  InteriorDoorsOpeningTypes,
  InteriorDoorsDesignPanel,
  InteriorDoorsGallery,
  InteriorDoorsTrendsSection,
  InteriorDoorsUtpCardSection,
} from './components';

/**
 * Вью страницы "Межкомнатные двери"
 */
export const InteriorDoors: React.FC = () => {
  const { elRef, onScrollToElement } = useScrollToElement();
  const isConsultationFormVisible = useIsInViewport(elRef, { threshold: 0 });

  return (
    <RootLayout currentPage={INTERIOR_DOORS_PATH}>
      <HeaderSection
        bgColor="#7F7B7A"
        description="Поможем подобрать двери и&nbsp;аксессуары под ваш интерьер с&nbsp;учётом пожеланий по&nbsp;стилю и&nbsp;бюджету. Сопровождаем на&nbsp;всех этапах: от&nbsp;замера до&nbsp;установки."
        img={{
          ldSrcSet: `${INTERIOR_DOORS_HEADER_CDN_PATH}/header/header-new-ld.jpg/header-new-ld-2.jpg`,
          dSrcSet: `${INTERIOR_DOORS_HEADER_CDN_PATH}/header/header-new-d.jpg/header-new-d-2.jpg`,
          tSrcSet: `${INTERIOR_DOORS_HEADER_CDN_PATH}/header/header-new-t.jpg/header-new-t-2.jpg`,
          mSrcSet: `${INTERIOR_DOORS_HEADER_CDN_PATH}/header/header-new-m.jpg/header-new-m-2.jpg`,
          title: 'Межкомнатные двери на заказ',
          alt: 'Межкомнатные двери на заказ',
        }}
        mediaType="image"
        title="Межкомнатные двери на заказ"
      />
      <InteriorDoorsDesignPanel
        isConsultationFormVisible={isConsultationFormVisible}
        onConsultationSignupBtnClick={onScrollToElement}
      />
      <Layout>
        <PromoBlock elementBlock={INTERIOR_DOORS_ELEMENT_BLOCK} />
        <SpecialOffer onModalBtnClick={onScrollToElement} elementBlock={INTERIOR_DOORS_ELEMENT_BLOCK} />
        <InteriorDoorsUtpCardSection onConsultationSignupBtnClick={onScrollToElement} />
      </Layout>
      <InteriorDoorsTrendsSection onConsultationSignupBtnClick={onScrollToElement} />
      <Layout>
        <InteriorDoorsModernMaterials />
        <InteriorDoorsOpeningTypes />
        <InteriorDoorsGallery onConsultationSignupBtnClick={onScrollToElement} />
        <ConsultationSection
          consultationType="INTERIOR_DOOR"
          elementBlock={INTERIOR_DOORS_ELEMENT_BLOCK}
          elementText="Заявка на консультацию и замер"
          servicesSale
          sectionRef={(el: HTMLElement | null) => {
            elRef.current = el;
          }}
          sectionText="Отправьте заявку, мы&nbsp;перезвоним в&nbsp;ближайшее время, бесплатно проконсультируем и&nbsp;запишем на&nbsp;замер."
          sectionTitle="Заявка на консультацию и&nbsp;замер"
        />
      </Layout>
      <OtherSection
        elementBlock={`${INTERIOR_DOORS_ELEMENT_BLOCK} / other`}
        landingName={INTERIOR_DOORS_OLD_LANDING_NAME}
        promotionName={`${INTERIOR_DOORS_ELEMENT_BLOCK}_bottom`}
      />
    </RootLayout>
  );
};
